<app-example-wrapper-seamless sectionHeading="Airlines">
    <div class="row">
        <div class="col-xl-12">
            <div class="card card-box mb-5">
                <div class="card-body">
                    <div class="d-flex justify-content-between pb-3">
                        <div class="search-wrapper">
                            <span class="icon-wrapper text-black">
                                <fa-icon [icon]="['fas', 'search']"></fa-icon>
                            </span>
                            <input type="text" class="form-control form-control-sm rounded-pill" pqlaceholder="Search..."
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchText">
                        </div>
                        <div>
                            <button class="btn btn-sm btn-primary" type="button" (click)="addAirlineService()"
                                id="addTeamMember">
                                <span class="btn-wrapper--icon">
                                    <fa-icon [icon]="['fas', 'plus']" class="opacity-8 font-size-xs" class="text-white">
                                    </fa-icon>
                                </span>
                                <span class="btn-wrapper--label">
                                    Add Airline
                                </span>
                            </button>
                            <button (click)="getData()" tooltip="Refresh" id="reloadEmployees"
                                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                type="button">
                                <span class="btn-wrapper--icon">
                                    <i class="ion-md-sync"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="allairlineServices | tsearch:searchText; let filteredAirlines">
                        <div class="table-responsive table-scroll">
                            <table class="table table-hover table-striped table-bordered text-nowrap mb-3" [mfRowsOnPage]="100" #mf="mfDataTable" [mfData]="filteredAirlines" [mfActivePage]="activePage"> 
                                <thead>
                                    <tr> 
                                        <th class="bg-white text-left">Airline Number</th>
                                        <th class="bg-white text-left">Airline Name</th>
                                        <th class="bg-white text-left">Airline Combined</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let airline of mf.data ; let i=index">
                                        <td>{{airline.airlineIataid}}</td>
                                        <td>{{airline.fullName}}</td>
                                        <td>{{airline.combinedName}}</td>
                                    </tr>
                                </tbody>

                                <tfoot>
                                    <tr>
                                        <td colspan="3">
                                            <span class="font-weight-bold text-primary">Total Airline Services: {{filteredAirlines.length}}
                                                </span>
                                            &nbsp;&nbsp;&nbsp; 
                                            <mfBootstrapPaginator [rowsOnPageSet]="[200,400,600,800,1000]">
                                            </mfBootstrapPaginator>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-example-wrapper-seamless>
<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>

